import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import useTypedDispatch from '../../../../hooks/useTypedDispatch';
import usePopup from '../../../../hooks/usePopup';
import { setFlag, removeFlag } from '../../../../store/actions/Entity/Flag';
import { PostType } from '../../../../types';
import InappropriateButtonPopup from './Popup';

import './style.scss';

export interface InappropriateButtonProps {
  postId: number;
  postType: PostType;
  value: boolean;
}

const InappropriateButton: React.FC<InappropriateButtonProps> = ({
  postId,
  postType,
  value,
}) => {
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();
  const flagType = postType === 'node' ? 'inappropriate_post' : 'inappropriate';
  const [latchedValue, setLatchedValue] = useState(value);
  const [loading, setLoading] = useState(false);

  const popup = usePopup(`InappropriateButtonPopup-${postId}`, {
    closeOnOutsideClick: true,
  });

  const toggleLike = async () => {
    if (latchedValue) {
      await dispatch(removeFlag(flagType, postType, postId));
      setLatchedValue(false);
    } else {
      popup.open();
    }
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const fieldData = {
      // eslint-disable-next-line max-len
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      field_reason: [{ value: values.body }],
    };

    try {
      await dispatch(setFlag(flagType, postType, postId, fieldData));
    } catch (error) {
      console.error(error);
    }

    setLatchedValue(true);
    popup.close();
    setLoading(false);
  };

  const classes = classNames('InappropriateButton', {
    'InappropriateButton--loading': loading,
  });

  return (
    <div className={classes}>
      <button
        className="icon-before icon-warning"
        type="button"
        onClick={toggleLike}
      >{latchedValue ? t('common:pages.forum.flag_inappropriate_form.cancel') : t('common:pages.forum.flag_inappropriate_form.button')}
      </button>
      {popup.isOpen && (
        ReactDOM.createPortal(
          <InappropriateButtonPopup
            loading={loading}
            onSubmit={onSubmit}
            {...popup.popupProps}
          />,
          document.body,
        )
      )}
    </div>
  );
};

export default InappropriateButton;
